import {Button, Card, Col, Form, Input, message, Row, Spin, Tooltip} from "antd";
import {forget_pw_img} from '../../../AppImageConst';
import Validation from "../../util/Validation";
import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLock} from "@fortawesome/free-solid-svg-icons";
import {ExclamationCircleOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import customerService from "../../service/customerService";
import {PASSWORD_VALIDATION} from "../../util/Constants";
import {
    MSG_ENTER_CURRENT_PASSWORD,
    MSG_INVALID_CURRENT_PASSWORD,
    MSG_PASSWORD_CHANGE_FAILURE,
    MSG_PASSWORD_CHANGE_SUCCESS,
    MSG_PASSWORD_VALIDATION_FAILURE_ERROR
} from "../../util/Messages";
import ErrorHandler from "../../util/ErrorHandler";
import {UserMstDto} from "../../dto/UserMstDto";
import modal from "antd/es/modal";
import keycloak from "../../security/KeyclockConfig";

const ChangePassword = () => {
    const [form] = Form.useForm();
    const [isSpinning, setSpinning] = useState<boolean>(false);
    const [loadingTip, setLoadingTip] = useState<string>("Loading");
    const [correctCurrentPassword, setCorrectCurrentPassword] = useState<string>();
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";

    const validatePassword = (_: any, value: any) => {

        if (!value) {
            return Promise.reject("Please enter your password");
        }
        if (value === correctCurrentPassword) {
            return Promise.reject("Cannot use your current password as the new password");
        }

        if (!PASSWORD_VALIDATION.test(value)) {
            return Promise.reject("Please enter a valid password");
        } else {
            return Promise.resolve();
        }

    };
    const preventDefaultEvent = (e: Event) => {
        e.preventDefault()
        return false;
    }
    const submitRequest = (val: any) => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to change your password?`,
            okText: 'Yes',
            cancelText: 'No',
            className: 'confirm-dialog-box',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                setSpinning(true)
                let userMstDto = {} as UserMstDto;
                userMstDto.password = val.newPassword
                customerService.changeUserPassword(userMstDto).then((res) => {
                    if (res.data.results) {
                        setLoadingTip("Logging out")
                        message.success(MSG_PASSWORD_CHANGE_SUCCESS)
                        form.resetFields()
                        setTimeout(()=>{
                            // keycloak.logout({redirectUri: `${redirectUri}`})
                            keycloak.logout({redirectUri: window.location.origin});
                        }, 1000)

                    } else {
                        message.error(MSG_PASSWORD_CHANGE_FAILURE)
                        setSpinning(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setSpinning(false)

                })
            },
            onCancel() {

            }
        });

    }
    // const getCustomerDataByCin = (cin: string) => {
    //     customerService.getCustomerDateByCin(cin).then(res => {
    //         if (res.data.results.customerMstDto != null) {
    //             const customerDto = res.data.results.customerMstDto as CustomerDto
    //             generateMobileOrEmail(customerDto.email, customerDto.mobileNo)
    //
    //
    //         }
    //
    //     }, (reason) => {
    //         ErrorHandler.handleError(reason);
    //
    //     })
    // }
    // type otpInputType =
    //     "numeric"
    //     | "alphabet"
    //     | "symbol"
    //     | "alphabet-symbol"
    //     | "alphabet-numeric"
    //     | "numeric-symbol"
    //     | "all";
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const [otpData, setOtpData] = useState<OtpDataDto>({
    //     message: "",
    //     otpRef: "",
    //     refId: "",
    //     retryCount: 0,
    //     tokenLength: 6,
    //     validityPeriod: 120,
    //     resendPeriod: 60,
    //     tokenType: "numeric",
    // });
    // const [otpDestination, setOtpDestination] = useState({type: "", destination: "", maskedDestination: ""});
    // const [isResendDisable, setIsResendDisable] = useState(true);
    // const [modalTitle, setModalTitle] = useState("");
    // const [timer, setTimer] = useState("");
    // const [value, setValue] = useState([]);

    // const timeoutRef = useRef<load>();
    // const otpFormRef: React.RefObject<HTMLFormElement> = React.createRef();

    // const showModal = () => {
    //     setIsModalOpen(true);
    // };
    // const generateMobileOrEmail = (email: string, mobileNo: string) => {
    //     let otpRequestDto: OtpRequestDto = {
    //         userName: "",
    //         destinations: [{
    //             type: OTP_DESTINATION_TYPE.EMAIL,
    //             destination: email
    //         },
    //             {
    //                 type: OTP_DESTINATION_TYPE.SMS,
    //                 destination: mobileNo
    //             }
    //         ]
    //     }
    //     setModalTitle("Password Verification")
    //     signupService.generateOtp(otpRequestDto).then((res: any) => {
    //         if (res.data !== null) {
    //             // message.success("Otp send successfully").then();
    //             let otpData: OtpDataDto = res.data.results;
    //             otpData.resendPeriod = 60
    //             setOtpData(otpData)
    //             setOtpDestination({
    //                 type: "SMS",
    //                 destination: mobileNo,
    //                 maskedDestination: maskEmailAndMobileNumber(mobileNo)
    //             })
    //             showModal();
    //             countdown(true)
    //         } else {
    //             message.error(MSG_OTP_SEND_FAILURE_ERROR).then();
    //
    //         }
    //     }, (reason) => {
    //         ErrorHandler.handleError(reason);
    //
    //     })
    // }
    // const countdown = (enable: boolean) => {
    //     let seconds = otpData.resendPeriod;
    //     setTimer("0:00")
    //
    //     function tick() {
    //         const minutesRemaining = Math.floor(seconds / 60);
    //         const secondsRemaining = seconds % 60;
    //         --seconds;
    //         setTimer(`${minutesRemaining.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`);
    //         if (seconds >= 0) {
    //             timeoutRef.current = setTimeout(tick, 1000);
    //             setIsResendDisable(true);
    //         } else {
    //             setIsResendDisable(false);
    //         }
    //     }
    //
    //     if (enable) {
    //         tick()
    //     } else {
    //         if (typeof timeoutRef.current === "number") {
    //             clearTimeout(timeoutRef.current);
    //         }
    //     }
    // }
    // const maskEmailAndMobileNumber = (value: string) => {
    //     let isEmail = value.includes("@");
    //     let valueArr: string[];
    //     valueArr = value.split('');
    //     let finalArr: string[] = [];
    //     let len = value.indexOf('@') > -1 ? value.indexOf('@') : value.length - 2;
    //     if (isEmail) {
    //         valueArr.forEach((item: any, pos: number) => {
    //             (pos >= 1 && pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
    //         })
    //         return finalArr.join('');
    //     } else {
    //         valueArr.forEach((item: any, pos: number) => {
    //             (pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
    //         })
    //         return finalArr.join('');
    //
    //     }
    // }
    // const handleCancel = () => {
    //     setIsModalOpen(false);
    //     // countdown(false)
    // };

    const validateCurrentPassword = (_: any, value: any, callback: any) => {
        if (value) {
            let userMstDto = {} as UserMstDto;
            userMstDto.password = value
            customerService.validateCurrentPassword(userMstDto).then(res => {
                if (res.data !== null) {
                    if (!res.data.results) {
                        callback(MSG_INVALID_CURRENT_PASSWORD)
                        setCorrectCurrentPassword(undefined)
                    } else {
                        callback()
                        setCorrectCurrentPassword(value)
                    }
                } else {
                    message.error(MSG_PASSWORD_VALIDATION_FAILURE_ERROR).then();
                    callback()
                    setCorrectCurrentPassword(undefined)
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                callback()
                setCorrectCurrentPassword(undefined)
            })
        } else {
            callback(MSG_ENTER_CURRENT_PASSWORD)
            setCorrectCurrentPassword(undefined)
        }

    };

    return (
        <Spin size="large" tip={loadingTip} spinning={isSpinning}>
            <Row gutter={[40, 0]} className={'right-side-container-margin'}>
                <Col lg={10} md={10} sm={0}
                     className={'left-side-main-container left-side-main-container-inside-dashboard'}>
                    <Row>
                        <Col span={24}>
                            <div className="clip-path-img">
                                <div className='clip-path-img-container'>
                                    <img src={forget_pw_img} alt="logo"/>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>

                <Col lg={14} md={14} sm={24}
                     className='right-side-main-container-inside-dashboard align-div-center dashboard-right-side-contaner-scroll layout-bottom-space'>
                    <Form
                        className='form-input'
                        layout={"vertical"}
                        initialValues={{remember: true}}
                        form={form}
                        onFinish={submitRequest}
                    >
                        <div className='account_type_container second-applicant-details' style={{paddingTop: 16}}>
                            <div>
                                <Row gutter={[32, 0]}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                                        <h2 className='page-header-main-title'>
                                            <div className='header_icon header-icon-center'>
                                                <FontAwesomeIcon icon={faLock} />
                                            </div>
                                            Change Password
                                        </h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Card className={'template_card'}>
                                            <Row gutter={[32, 0]}>
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Form.Item
                                                        name="currentPassword"
                                                        label="Current Password"
                                                        validateTrigger={["onBlur"]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        rules={[
                                                            {validator: validateCurrentPassword}
                                                        ]}
                                                    >
                                                        <Input.Password size="large"
                                                                        placeholder="Enter current password"
                                                                        autoComplete="new-password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Form.Item
                                                        name="newPassword"
                                                        label={<><span className='custom-astrix-pw-change'>*</span> New
                                                            Password
                                                            <Tooltip placement="right" className='password-info-tooltip'
                                                                     title={
                                                                         <ul style={{
                                                                             padding: '0 10px 0 18px',
                                                                             width: '100%'
                                                                         }}>
                                                                             <li>Minimum 8 characters</li>
                                                                             <li>Maximum 20 characters</li>
                                                                             <li>Should have at least one uppercase</li>
                                                                             <li>Should have at least one lowercase</li>
                                                                             <li>Should have at least one numerical
                                                                                 value
                                                                             </li>
                                                                             <li>Should have at least one special
                                                                                 character
                                                                                 (!, @, #, $, %, ^, &, _, or
                                                                                 *)
                                                                             </li>
                                                                         </ul>
                                                                     }>
                                                                <QuestionCircleOutlined style={{
                                                                    marginLeft: 5,
                                                                    color: '#108ee9',
                                                                    fontSize: 16
                                                                }}/>
                                                            </Tooltip>
                                                        </>}
                                                        rules={[
                                                            {validator: validatePassword},
                                                        ]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        hasFeedback>
                                                        <Input.Password size="large" placeholder="Enter new password"
                                                                        autoComplete="new-password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                                    <Form.Item
                                                        name="confirmNewPassword"
                                                        label="Confirm New password"
                                                        dependencies={['password']}
                                                        rules={
                                                            [{
                                                                required: true,
                                                                message: 'Please enter your confirm password'
                                                            },
                                                                // {max: 20, message: 'The maximum length is 20 characters'},
                                                                // {min: 8, message: 'Minimum of 8 characters are required'},
                                                                ({getFieldValue}: any) => ({
                                                                    validator(_: any, value: any) {
                                                                        if (!value || getFieldValue('newPassword') === value) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(new Error('Confirm password do not match'));
                                                                    },
                                                                })

                                                            ]}
                                                        onKeyPress={Validation.passwordFieldValidation}
                                                        hasFeedback>
                                                        <Input.Password size="large" placeholder="Confirm new password"
                                                                        autoComplete="new-password"
                                                                        onCopy={preventDefaultEvent}
                                                                        onPaste={preventDefaultEvent}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                {/*<Col lg={24} md={24} sm={24}>*/}
                                                {/*    <ul style={{padding: '0 10px 0 18px', width: '100%'}}>*/}
                                                {/*        <li>Minimum 8 characters</li>*/}
                                                {/*        <li>Maximum 20 characters</li>*/}
                                                {/*        <li>Should have at least one uppercase</li>*/}
                                                {/*        <li>Should have at least one lowercase</li>*/}
                                                {/*        <li>Should have at least one numerical value</li>*/}
                                                {/*        <li>Should have at least one special character (!, @, #, $, %, ^, &, _, or*/}
                                                {/*            *)*/}
                                                {/*        </li>*/}
                                                {/*    </ul>*/}
                                                {/*</Col>*/}
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>

                            <div>
                                <Row gutter={[32, 0]}>

                                    <Col sm={24} lg={{span: 8, offset: 16}} className='continue-btn-col text-right'>
                                        <Form.Item>
                                            <Button className='custom-btn-primary ant-btn margin_top_20'
                                                    htmlType="submit"
                                                    type="primary">
                                                Continue
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Form>

                </Col>
                {/*<Modal title={modalTitle}*/}
                {/*       open={isModalOpen}*/}
                {/*       destroyOnClose={true}*/}
                {/*       maskClosable={false}*/}
                {/*       closable={false}*/}
                {/*       className='otp-verification-modal'*/}
                {/*       footer={[*/}
                {/*           <Button*/}
                {/*               // disabled={isResendDisable}*/}
                {/*               onClick={handleCancel}*/}
                {/*               className='otp-close-btn'>Close</Button>,*/}
                {/*           <Button type="success"*/}
                {/*               // onClick={validateOtp}*/}
                {/*                   className='otp-verify-btn'>Verify</Button>,*/}
                {/*       ]}>*/}
                {/*    <p className='otp-sent-info'>Enter the OTP sent*/}
                {/*        to <b>{otpDestination.maskedDestination}</b></p>*/}

                {/*    <Form name="complex-form" ref={otpFormRef}>*/}
                {/*        <Form.Item>*/}

                {/*            <Form.Item*/}
                {/*                noStyle*/}
                {/*                name="userOtp"*/}
                {/*                rules={[{validator: async () => Promise.resolve()}]}*/}
                {/*            >*/}
                {/*                <InputOTP length={otpData.tokenLength}*/}
                {/*                          inputType={otpData.tokenType.toLowerCase() as otpInputType}*/}
                {/*                          onChange={() => setValue}*/}
                {/*                          value={value}/>*/}
                {/*            </Form.Item>*/}

                {/*            <Typography href="#API">*/}
                {/*                <p>Didn't you receive the OTP?*/}
                {/*                    <Button type="link" disabled={isResendDisable}*/}
                {/*                        // onClick={() => generateMobileOrEmail(otpDestination.type)}*/}
                {/*                    >*/}
                {/*                        Resend*/}
                {/*                    </Button>*/}
                {/*                    <span style={{float: 'right', paddingTop: 4}}>{timer}</span>*/}
                {/*                </p>*/}
                {/*            </Typography>*/}


                {/*        </Form.Item>*/}
                {/*    </Form>*/}

                {/*</Modal>*/}
            </Row>
        </Spin>

    )
}
export default ChangePassword